
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, lambda_type, unit_type, union_type, list_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, SetId, RequestedValue$1, FormState_get_empty, RequestedValue$1_$reflection, FormState_$reflection, TokenDataDto_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { Receiver_$reflection } from "../../Shared/User.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { DataTransfer_UnassignSetDto, DataTransfer_UnassignSetDto_$reflection, DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { ofArray, append, max, filter, tryPick, sumBy, choose, singleton, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unassignCmd } from "../../Requests/Set.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { uploadImage } from "../../Requests/Files.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnassignedResponse", "OnUnassign", "SetComment", "ReceiverFetched", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Sets.Dialog.UnassignDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", string_type]], [["Item", Receiver_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Set$, UserData, FormState, SuccessCallback, OnClose, Receiver, Dto, SenderImageFiles, ImageUploading) {
        super();
        this.Set = Set$;
        this.UserData = UserData;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Receiver = Receiver;
        this.Dto = Dto;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Sets.Dialog.UnassignDialog.State", [], State, () => [["Set", DataTransfer_DetailSet_$reflection()], ["UserData", TokenDataDto_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Receiver", RequestedValue$1_$reflection(Receiver_$reflection())], ["Dto", DataTransfer_UnassignSetDto_$reflection()], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function init(set$, userData, successCallback, onClose) {
    let matchValue;
    return [new State(set$, userData, FormState_get_empty(), successCallback, onClose, new RequestedValue$1(0, []), new DataTransfer_UnassignSetDto("", empty()), empty(), false), (matchValue = set$.LocationInformation.AssignedReceiverId, (matchValue == null) ? Cmd_none() : Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), Receiver_$reflection()));
    })))), concat("/api/receivers/receiver/", ...matchValue), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1]))))];
}

function update(msg, state) {
    let file_1;
    switch (msg.tag) {
        case 3:
            return [new State(state.Set, state.UserData, state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Dto, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 1: {
            const matchValue = state.Set.LocationInformation.AssignedReceiverId;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const assignedReceiver = matchValue;
                const senderImageUrls = choose((f) => {
                    if (f.tag === 1) {
                        return f.fields[0].ImageUrl;
                    }
                    else {
                        return undefined;
                    }
                }, state.SenderImageFiles);
                return [new State(state.Set, state.UserData, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading), unassignCmd(new SetId(parse(state.Set.Id)), new DataTransfer_UnassignSetDto(state.Dto.Comment, senderImageUrls), (Item_1) => (new Msg(0, [Item_1])), (Item_2) => (new Msg(4, [Item_2])))];
            }
        }
        case 2:
            return [new State(state.Set, state.UserData, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, new DataTransfer_UnassignSetDto(msg.fields[0], empty()), state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 4:
            return [new State(state.Set, state.UserData, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, false), Cmd_none()];
        case 5: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Set, state.UserData, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, newFiles, true), uploadImage((Item_3) => (new Msg(6, [Item_3])), (Item_4) => (new Msg(4, [Item_4])), formData)];
                }
                default:
                    return [new State(state.Set, state.UserData, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 6: {
            const response_2 = msg.fields[0];
            switch (response_2.tag) {
                case 0:
                    return [new State(state.Set, state.UserData, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Set, state.UserData, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    })) | 0;
                    return [new State(state.Set, state.UserData, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_2.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Set, state.UserData, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Set, state.UserData, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
    }
}

function DialogBody(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const formState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5"])], (elems_2 = toList(delay(() => {
        let arg_1;
        return append_1(singleton_1(reactElement("p", {
            children: (arg_1 = {
                user: props.Receiver.Name,
            }, patternInput[1].t("tool.dialog_unassign_tool_query", arg_1)),
        })), delay(() => {
            let elems;
            return append_1(singleton_1(reactElement("div", createObj(singleton((elems = [createElement(TextArea, {
                ComponentState: formState,
                Label: t("general.comment"),
                OnChange: props.SetComment,
                TestId: "unassign-tool-dialog-comment-test-id",
                Value: props.Comment,
            })], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => {
                let elems_1;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_1 = [createElement(TextValue, {
                    FontWeight: "bold",
                    TestId: "",
                    Text: t("assignment_notification.sender_images"),
                }), createElement(ImageUpload, {
                    ComponentState: props.ImageUploading ? "disabled" : formState,
                    SelectedFiles: props.SenderImageFiles,
                    SetSelectedFile: props.SetSelectedSenderFiles,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    const matchValue = FormState__getValidation(props.FormState, t, "global");
                    if (matchValue == null) {
                        return empty_1();
                    }
                    else {
                        return singleton_1(createElement(ErrorAlert, {
                            Label: matchValue,
                        }));
                    }
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function OpenUnassignDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Set, props.UserData, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    if (state_1.Set.LocationInformation.AssignedReceiverId == null) {
        return defaultOf();
    }
    else {
        return createElement(Dialog, (Title = t("tool.back_to_storage"), {
            Body: toList(delay(() => {
                const matchValue_1 = state_1.Receiver;
                return (matchValue_1.tag === 0) ? singleton_1(createElement(Skeleton, {
                    Variant: "normal",
                })) : singleton_1(createElement(DialogBody, {
                    Comment: state_1.Dto.Comment,
                    FormState: state_1.FormState,
                    ImageUploading: state_1.ImageUploading,
                    Receiver: matchValue_1.fields[0],
                    SenderImageFiles: state_1.SenderImageFiles,
                    SetComment: (value) => {
                        dispatch(new Msg(2, [value]));
                    },
                    SetSelectedSenderFiles: (files) => {
                        dispatch(new Msg(5, [files]));
                    },
                }));
            })),
            Controls: ofArray([createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("general.cancel"),
                OnClick: props.OnClose,
                TestId: "close-reservation-dialog-test-id",
                Variant: "blueButton",
            }), createElement(TextButton, {
                ComponentState: (state_1.FormState.IsLoading ? true : state_1.ImageUploading) ? "disabled" : "enabled",
                Label: t("general.save"),
                OnClick: () => {
                    dispatch(new Msg(1, []));
                },
                TestId: "save-unassign-dialog-test-id",
                Variant: "blueButton",
            })]),
            IsOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: Title,
        }));
    }
}

